import { z } from 'zod'
import dayjs from 'dayjs'

// 탭② 카테고리 단가 — 등록 / 수정 폼 (키 = 물류카테고리 1축·bizest 미사용·FR-PM05)
export const categoryPriceFormSchema = z
  .object({
    country: z.string().min(1, '국가를 선택해 주세요.'),
    serviceType: z.string().min(1, '서비스 이용항목을 선택해 주세요.'),
    orderType: z.string().min(1, '주문유형을 선택해 주세요.'),
    logisticsCategoryCode: z.string().min(1, '물류카테고리를 선택해 주세요.'),
    unitType: z.string().min(1, '단위를 선택해 주세요.'),
    unitPrice: z
      .string()
      .min(1, '단가를 입력해 주세요.')
      .refine((val) => !Number.isNaN(Number(val)), '숫자만 입력 가능해요.')
      .refine((val) => Number(val) > 0, '0보다 큰 수를 입력해 주세요.'),
    startDate: z.string().min(1, '시작일을 선택해 주세요.'),
    endDate: z.string().min(1, '종료일을 선택해 주세요.'),
  })
  .superRefine((val, ctx) => {
    // 종료일은 시작일 다음날부터 (end_date > start_date·FR-PM11)
    if (val.startDate && val.endDate && !dayjs(val.endDate).isAfter(dayjs(val.startDate), 'day')) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['endDate'], message: '종료일은 시작일 다음날 이후여야 합니다.' })
    }
  })

export type CategoryPriceFormSchemaType = z.infer<typeof categoryPriceFormSchema>

export const getInitForm = (defaultValues: Partial<CategoryPriceFormSchemaType> = {}): CategoryPriceFormSchemaType => {
  return {
    country: defaultValues.country ?? '',
    serviceType: defaultValues.serviceType ?? '',
    orderType: defaultValues.orderType ?? '',
    logisticsCategoryCode: defaultValues.logisticsCategoryCode ?? '',
    unitType: defaultValues.unitType ?? 'PCS', // 등록 폼 단위 선택(PCS/BOX), 기본 PCS — LOGISPRD-9632
    unitPrice: defaultValues.unitPrice ? String(defaultValues.unitPrice) : '',
    startDate: defaultValues.startDate ?? '',
    endDate: defaultValues.endDate ?? '',
  }
}
